"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionNFT = exports.Trade = exports.Term = void 0;
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
const MethodConfig_1 = __importDefault(require("../../interface/MethodConfig"));
const config_1 = __importDefault(require("../../config"));
const types = [
    'earn',
    'long',
    'short'
];
class Term {
}
exports.Term = Term;
class Trade {
}
exports.Trade = Trade;
class PositionNFT {
}
exports.PositionNFT = PositionNFT;
class PositionNFTs {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.COMPLETELY;
        this.id = 'xBifi.positionNFTs';
        this.entryPointID = 'xBifi';
        this.defaultDecimals = new bifrost_number_1.default('10').pow(config_1.default.default.decimals);
    }
    getMethodProps() {
        return [new MethodConfig_1.default('xBifi.positionNFTs', [], 'xBifi')];
    }
    proccessCallResponse(responses, isValidAddress, network) {
        const result = [];
        const positionNFTs = (responses[0] || [])[0] || [];
        for (const positionNFT of positionNFTs) {
            const rawPositionState = positionNFT[0];
            const rawPositionAddress = positionNFT[1];
            const rawScope = positionNFT[2];
            const rawSrcHandlerID = positionNFT[3];
            const rawDstHandlerID = positionNFT[4];
            const rawSrcAsset = positionNFT[6];
            const rawDstAsset = positionNFT[7];
            const rawSrcPrice = positionNFT[8];
            const rawDstPrice = positionNFT[9];
            const rawSrcCurrentPrice = positionNFT[10];
            const rawDstCurrentPrice = positionNFT[11];
            const rawLtv = positionNFT[12];
            const rawDepositAmount = positionNFT[14];
            const rawBorrowAmount = positionNFT[15];
            const rawDepositInterestAmount = positionNFT[16];
            const rawBorrowInterestAmount = positionNFT[17];
            const rawBifiReward = positionNFT[18];
            const address = rawPositionAddress || '';
            const type = types[parseInt(rawPositionState) || 0] || '';
            const lengthType = type !== 'earn' ? type : '';
            const ltv = new bifrost_number_1.default(rawLtv || '0').div(this.defaultDecimals).toStr();
            const boostRate = new bifrost_number_1.default(rawScope || '0').div(this.defaultDecimals).toStr();
            const rewardAmount = new bifrost_number_1.default(rawBifiReward || '0').div(this.defaultDecimals).toStr();
            const depositHandlerID = parseInt(rawSrcHandlerID);
            const depositTokenID = network.getHandlerTokenID(depositHandlerID);
            const depositAmount = new bifrost_number_1.default(rawDepositAmount || '0').div(this.defaultDecimals).toStr();
            const depositInterestAmount = new bifrost_number_1.default(rawDepositInterestAmount || '0').div(this.defaultDecimals).minus(depositAmount).toStr();
            const depositAppraisedPriceValue = new bifrost_number_1.default(rawSrcCurrentPrice || '0').div(this.defaultDecimals);
            const depositAppraisedPrice = depositAppraisedPriceValue.toStr();
            const depositAppraisedAmount = depositAmount;
            const depositAppraisedAsset = depositAppraisedPriceValue.mul(depositAppraisedAmount).toStr();
            const depositPrincipalAssetValue = new bifrost_number_1.default(rawSrcAsset || '0').div(this.defaultDecimals);
            const depositPrincipalAsset = depositPrincipalAssetValue.toStr();
            const depositPrincipalPrice = new bifrost_number_1.default(rawSrcPrice || '0').div(this.defaultDecimals).toStr();
            const depositPrincipalAmount = depositPrincipalAssetValue.div(depositPrincipalPrice).toStr();
            const borrowHandlerID = parseInt(rawDstHandlerID);
            const borrowTokenID = network.getHandlerTokenID(borrowHandlerID);
            const borrowAmount = new bifrost_number_1.default(rawBorrowAmount || '0').div(this.defaultDecimals).toStr();
            const borrowInterestAmount = new bifrost_number_1.default(rawBorrowInterestAmount || '0').div(this.defaultDecimals).minus(borrowAmount).toStr();
            const borrowAppraisedPriceValue = new bifrost_number_1.default(rawDstCurrentPrice || '0').div(this.defaultDecimals);
            const borrowAppraisedPrice = borrowAppraisedPriceValue.toStr();
            const borrowAppraisedAmount = borrowAmount;
            const borrowAppraisedAsset = borrowAppraisedPriceValue.mul(borrowAppraisedAmount).toStr();
            const borrowPrincipalAssetValue = new bifrost_number_1.default(rawDstAsset || '0').div(this.defaultDecimals);
            const borrowPrincipalAsset = borrowPrincipalAssetValue.toStr();
            const borrowPrincipalPrice = new bifrost_number_1.default(rawDstPrice || '0').div(this.defaultDecimals).toStr();
            const borrowPrincipalAmount = borrowPrincipalAssetValue.div(borrowPrincipalPrice).toStr();
            const deposit = {
                handlerID: depositHandlerID,
                tokenID: depositTokenID,
                amount: depositAmount,
                interestAmount: depositInterestAmount,
                appraised: {
                    price: depositAppraisedPrice,
                    amount: depositAppraisedAmount,
                    asset: depositAppraisedAsset
                },
                principal: {
                    price: depositPrincipalPrice,
                    amount: depositPrincipalAmount,
                    asset: depositPrincipalAsset
                }
            };
            const borrow = {
                handlerID: borrowHandlerID,
                tokenID: borrowTokenID,
                amount: borrowAmount,
                interestAmount: borrowInterestAmount,
                appraised: {
                    price: borrowAppraisedPrice,
                    amount: borrowAppraisedAmount,
                    asset: borrowAppraisedAsset
                },
                principal: {
                    price: borrowPrincipalPrice,
                    amount: borrowPrincipalAmount,
                    asset: borrowPrincipalAsset
                }
            };
            result.push({
                address,
                type,
                lengthType,
                ltv,
                boostRate,
                rewardAmount,
                deposit,
                borrow
            });
        }
        return result;
    }
}
exports.default = PositionNFTs;
;
//# sourceMappingURL=PositionNFTs.js.map